import { Stack, styled } from '@mui/material';

import { colors } from '../../components';

export const OverViewWrapper = styled(Stack)(({ theme }) => ({
    backgroundColor: colors.primaryLight[5],
    borderRadius: theme.spacing(2),
    '& .cardWrapper': {
        backgroundColor: colors.fullWhite,
        padding: theme.spacing(1.5),
        borderRadius: theme.spacing(1),
    },
}));

export const OverviewSectionCard = styled(Stack)(({ theme }) => ({
    backgroundColor: colors.fullWhite,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    gap: theme.spacing(2),
}));

export const OverviewSectionHeader = styled(Stack)(({ theme }) => ({
    borderBottom: `1px solid ${colors.greyPreset[90]}`,
    paddingBottom: theme.spacing(1.5),
}));

export const OverviewNestedCard = styled(Stack)(({ theme }) => ({
    backgroundColor: colors.primaryLight[5],
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5),
    gap: theme.spacing(1),
}));
